module.exports = __webpack_public_path__ + "img/mac_mobile_ru.0d459661.png";